import React, { useCallback } from 'react';

import useOnIntersect from '@rover/react-lib/src/hooks/useOnIntersect';
import { emitAnalyticsEvent } from '@rover/rsdk/src/modules/Analytics';

import { SectionViewed } from '../../utilities/analyticsEvents';

export enum PageSectionId {
  HowBrandWorks = 'HowBrandWorks',
  WhyChooseRover = 'WhyChooseRover',
  FAQs = 'FAQs',
  CarouselSearchResults = 'CarouselSearchResults',
  DefaultSearchResults = 'DefaultSearchResults',
  ReviewsCarousel = 'ReviewsCarousel',
  RoverGuarantee = 'RoverGuarantee',
  ValuePropFilterOptions = 'ValuePropFilterOptions',
  Footer = 'Footer',
}

const emitSectionViewedMetric = (sectionId: PageSectionId): void => {
  emitAnalyticsEvent(new SectionViewed({ sectionId }));
};

export function useSectionRef(
  pageSectionId: PageSectionId,
  options?: IntersectionObserverInit
): React.RefObject<HTMLElement> {
  const handleSectionVisible = useCallback(() => {
    emitSectionViewedMetric(pageSectionId);
  }, [pageSectionId]);
  const sectionRef = useOnIntersect(handleSectionVisible, true, options);

  return sectionRef;
}
